import { useHistory } from 'react-router-dom';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { faBadgeCheck, faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as DropdownMenu from 'components/dropdown-menu';
import { useSearchStore } from 'components/search/useSearchStore';
import { useFiltersCache } from 'contexts/useFiltersCache';
import { useAppState } from 'customHooks/useAppState';
import { useCloseSidebar } from 'customHooks/useCloseSidebar';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useFetchAccounts } from 'customHooks/useFetchAccounts';
import { MiniAccount } from 'types/domain';

const AccountSwitcher = () => {
    const { name } = useCurrentAccount();
    const { data: accounts } = useFetchAccounts();
    const apiUrl = useAppState(state => state.apiUrl);
    const closeSidebar = useCloseSidebar();
    const clearGlobalSearch = useSearchStore(state => state.clear);
    const history = useHistory();
    const setFilters = useFiltersCache(state => state.setFilters);

    const onClickOverlayLink = (item: MiniAccount) => {
        history.push(`/accounts/${item.id}`);
        closeSidebar();
        clearGlobalSearch();
        setFilters({});
    };

    return (
        <DropdownMenu.Root>
            <DropdownMenu.Trigger className="group/trigger flex min-h-14 w-full min-w-0 items-center justify-start gap-2 pl-3">
                <div className="min-w-0">
                    <p className="flex items-center gap-2 text-left">
                        <span className="line-clamp-2 text-sm font-medium leading-tight text-gray-900">
                            {name}
                        </span>
                    </p>
                </div>

                <div className="flex h-4 w-4 items-center justify-center rounded-md group-hover/trigger:bg-gray-100">
                    <FontAwesomeIcon
                        size="sm"
                        icon={faChevronDown}
                        className="text-gray-700 group-[[data-state=open]]/trigger:rotate-180"
                    />
                </div>
            </DropdownMenu.Trigger>
            <DropdownMenu.Content side="bottom" align="start" sideOffset={4} className="w-64">
                <div className="max-h-44 overflow-y-auto">
                    {accounts.map((item: MiniAccount) => (
                        <DropdownMenu.LinkItem
                            to={`/accounts/${item.id}/home`}
                            onClick={() => onClickOverlayLink(item)}
                            key={item.id}
                            bubbles
                        >
                            <div className="flex items-center gap-2">
                                <p className="min-w-0 truncate">{item.name}</p>
                                {item.is_verified ? (
                                    <FontAwesomeIcon
                                        icon={faBadgeCheck}
                                        className="text-green-500"
                                    />
                                ) : null}
                            </div>
                        </DropdownMenu.LinkItem>
                    ))}
                </div>
                <DropdownMenu.Separator />
                <DropdownMenu.Item>
                    <a
                        href={`${apiUrl + '/signup/new'}`}
                        className="flex items-center gap-2 text-blue-500"
                    >
                        <FontAwesomeIcon icon={faPlus} />
                        Create new account
                    </a>
                </DropdownMenu.Item>
            </DropdownMenu.Content>
        </DropdownMenu.Root>
    );
};

export { AccountSwitcher };
